<template>
  <div style="background-color: white; min-height: 100vh">
    <v-app>
      <Header />
      <div class="page-wrap">
        <v-breadcrumbs
          divider="/"
          :items="breadcrumbs"
          class="breadcrumbs"
        ></v-breadcrumbs>
        <div style="padding: 0px 12px 12px 12px" class="width100">
          <div class="waiver-wrapper">
            <h1>Participant Registration</h1>
            <div class="boxes">
              <div v-for="n in adults" :key="n" class="box">
                <p>Participant #{{ n }}</p>
                <div class="waiver-inputs">
                  <v-text-field
                    class="waiver-input"
                    type="text"
                    placeholder="First Name"
                    label="First Name"
                    v-model="participants[n - 1].firstname"
                    :autocomplete="'off'"
                    :rules="[(v) => !!v || 'First name is required']"
                  ></v-text-field>
                  <v-text-field
                    class="waiver-input"
                    type="text"
                    placeholder="Last Name"
                    label="Last Name"
                    :autocomplete="'off'"
                    v-model="participants[n - 1].lastname"
                    :rules="[(v) => !!v || 'Last name is required']"
                  ></v-text-field>
                  <v-text-field
                    class="waiver-input"
                    type="text"
                    placeholder="Email"
                    :autocomplete="'off'"
                    label="Email"
                    v-model="participants[n - 1].email"
                    :rules="[(v) => !!v || 'Email is required']"
                  ></v-text-field>
                </div>
              </div>
            </div>
            <div class="align-green-btn">
              <button
                class="green-btn"
                :disabled="!isFormValid()"
                :class="{ notValid: !isFormValid() }"
                @click="submitForm()"
              >
                Checkout
              </button>
            </div>
          </div>
        </div>
        <div id="shopifyCollectionWrap" class="shopifyCollectionWrap">
          <div
            id="collection-component-1616176464282"
            class="collectionDiv"
          ></div>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script src="https://evey-files.s3.amazonaws.com/js/evey_buy_button.js"></script>

<script>
import Header from "../../../components/Header.vue";
import $ from "jquery";
export default {
  name: "StarvationSpeciesWaiver",
  metaInfo: {
    title: "Starvation Species Sprint Waiver",
    meta: [
      {
        name: "description",
        content:
          "Purchase your day-use pass for Fred Hayes Starvation Species Sprint Event.",
      },
    ],
  },
  components: {
    Header,
  },
  data() {
    return {
      breadcrumbs: [],
      count: 0,
      adults: 0,
      participants: [],
      continueButton: false,
      varientId: this.$route.params.id,
      uuid: "",
      date: "",
    };
  },
  created() {
    this.uuid = this.generateUUID();
    console.log("participant: ", this.participant);
    console.log("varientId: " + this.varientId);
    this.adults = Number(localStorage.getItem("numberOfAdults") || 0);
    this.count = this.adults;
    for (let i = 0; i < this.count; i++) {
      this.participants.push({
        agreed: true,
        event: "45464593465497",
        passId: this.uuid,
        firstname: "",
        lastname: "",
        email: "",
        minor: "0",
        guardianFirstName: "",
        guardianLastName: "",
        variantId: "45464593465497",
      });
    }
    this.breadcrumbs = [
      { text: "Home", disabled: false, href: "/" },
      {
        text: "Fred Hayes State Park at Starvation",
        disabled: false,
        href: "/parks/" + this.$route.params.name + "/dayuse",
      },
      {
        text: "Starvation Species Sprint",
        disabled: false,
        href: "/parks/UTFRED/StarvationSpecies",
      },
      { text: "Waiver", disabled: true },
    ];
  },
  mounted() {},
  methods: {
    isFormValid() {
      const p = this.participants;
      for (let i = 0; i < p.length; i++) {
        if (!this.isParticipantValid(p[i])) {
          return false;
        }
      }
      return true; //
    },
    isParticipantValid(participant) {
      const p = participant;
      if (!p) return false;
      return p.firstname && p.lastname && p.email;
    },
    submitForm() {
      var _this = this;
      for (let f in this.participants) {
        var data = this.participants[f];
        console.log("data: ", data);
        data = JSON.stringify(data);
        console.log("data: ", data);
        $.ajax({
          url: "https://trailwaze.info/waivers/addWaiver.php",
          type: "POST",
          dataType: "json",
          data: data,
          success: function (json) {
            _this.json = json;
            console.log("new json: ", _this.json);
          },
          error: function (xhr, status, error) {
            console.log("Error: " + error);
          },
        });
      }

      this.MakeShiftShopify();
    },
    generateUUID() {
      // Public Domain/MIT
      let d = new Date().getTime(); //Timestamp
      let d2 =
        (performance && performance.now && performance.now() * 1000) || 0; //Time in microseconds since page-load or 0 if unsupported
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          let r = Math.random() * 16; //random number between 0 and 16
          if (d > 0) {
            //Use timestamp until depleted
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
          } else {
            //Use microseconds since page-load if supported
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
          }
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },
    MakeShiftShopify() {
      console.log("make shift shopify");
      var client = ShopifyBuy.buildClient({
        domain: "parkspassutah.myshopify.com",
        storefrontAccessToken: "a245460c3b59913598a8b8b1f049af40",
      });

      var variantId1 = "45464593465497";
      var quantity1 = this.adults;
      variantId1 = window.btoa(`gid://shopify/ProductVariant/${variantId1}`);

      // Generate a UUID
      const uuid = this.uuid;

      // Create an array to hold custom attributes
      let customAttributes = [
        { key: "UUID", value: uuid },
        { key: "event_date", value: this.date },
      ];

      // Loop through AdultData and add full names as custom attributes
      for (let i = 0; i < this.participants.length; i++) {
        console.log("Participant: ", this.participants[i]);
        const fullName = `${this.participants[i].firstname} ${this.participants[i].lastname}`;
        customAttributes.push({
          key: `participant${i + 1}`,
          value: fullName,
        });
      }

      client.checkout
        .create({
          customAttributes: customAttributes,
        })
        .then((checkout) => {
          var lineItemsToAdd = [
            {
              variantId: variantId1,
              quantity: quantity1,
            },
          ];
          return client.checkout.addLineItems(checkout.id, lineItemsToAdd);
        })
        .then((checkout) => {
          // Direct the user to the checkout
          window.location.href = checkout.webUrl;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
  },
};
</script>

<style scoped>
p {
  line-height: 22px;
}
.v-card-text {
  max-height: 60vh;
  overflow-y: auto;
}
.greenLink {
  color: #96a145;
  font-size: 16px;
  font-family: "boldRoboto";
  margin: 16px 0px;
  display: block;
  cursor: pointer;
}
.green-btn {
  height: 42px;
  line-height: 42px;
  border-radius: 32px;
  background-color: #96a145;
  color: white;
  width: 140px;
  padding: 0px 16px;
  text-align: center;
  font-size: 16px;
  font-family: "regularRoboto";
  margin-top: 8px;
  cursor: pointer;
}
.green-btn:hover {
  background-color: #818a3c;
}
.align-green-btn {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 20px;
}
/* Customize the label (the container) */
.v-breadcrumbs ::v-deep(a) {
  color: #96a145 !important;
}
.breadcrumbs {
  margin: 20px 20px;
}
v-btn {
  background-color: none !important;
  color: rgb(53, 53, 53) 5 !important;
}
.waiver-wrapper {
  width: 70%;
  margin: 30px;
  display: flex;
  flex-direction: column;
}
.waiver-wrapper h1 {
  font-size: 40px;
  font-family: "boldRoboto";
  margin-bottom: 40px;
  line-height: 1.3;
}
.width100 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.boxes {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.box {
  width: 100%;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
}
.box p {
  font-size: 20px;
  font-family: "boldRoboto";
  margin-bottom: 16px;
}
.waiver-inputs {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  gap: 16px;
  align-items: flex-end;
}
.waiver-input {
  width: 100%;
  border-radius: 8px;
  outline-color: #818a3c;
}
.notValid {
  background-color: #d9d9d9 !important;
  cursor: not-allowed;
}
@media only screen and (max-width: 850px) {
  .page-wrap {
    padding: 16px;
  }
  .waiver-inputs {
    flex-direction: column;
    align-items: flex-start;
  }
  .waiver-wrapper {
    margin: 0px;
    width: 100%;
  }
}
.disclaimer-link {
  display: inline;
  color: #96a145;
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
  margin-left: 5px;
}
.v-input--is-label-active .v-label {
  background-color: white;
  padding: 0 4px;
}
</style>
